import { styled } from '@compiled/react';
import { N0, N200, B400, N40A } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { XL_MIN_WIDTH, DESKTOP_MIN_WIDTH } from '../../common/constants';

// eslint-disable-next-line rulesdir/no-styled-export
export const Form = styled.form({
    flex: '1 0 auto',
});

// eslint-disable-next-line rulesdir/no-styled-export
export const Input = styled.input({
    borderRadius: 8,
    fontSize: 14,
    paddingBlock: token('space.150', '12px'),
    paddingLeft: token('space.600', '48px'),
    paddingRight: token('space.200', '16px'),
    width: '100%',
    boxSizing: 'border-box',
    border: 0,
    outline: 'none',
    backgroundColor: 'transparent',
    '::placeholder': {
        color: token('color.text.subtlest', N200),
    },
});

// eslint-disable-next-line rulesdir/no-styled-export
export const Container = styled.div<{ isConversationView: boolean }>({
    display: 'flex',
    transition: 'all 0.5s ease',
    paddingLeft: token('space.150', '12px'),
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/ensure-design-token-usage
    paddingRight: ({ isConversationView }) =>
        isConversationView
            ? `calc(${token('space.800', '64px')} + ${token('space.050', '4px')})`
            : token('space.150', '12px'),
    [`@media only screen and (min-width: ${DESKTOP_MIN_WIDTH}px)`]: {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/ensure-design-token-usage
        paddingLeft: ({ isConversationView }) =>
            isConversationView
                ? `calc(20vw  + ${token('space.400', '32px')} + ${token('space.025', '2px')} + ${token(
                      'space.150',
                      '12px'
                  )})`
                : `calc(20vw  + ${token('space.150', '12px')})`,

        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/ensure-design-token-usage
        paddingRight: ({ isConversationView }) =>
            isConversationView
                ? `calc(20vw  + ${token('space.400', '32px')})`
                : `calc(20vw  + ${token('space.150', '12px')})`,
    },

    [`@media only screen and (min-width: ${XL_MIN_WIDTH}px)`]: {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/ensure-design-token-usage
        paddingLeft: ({ isConversationView }) =>
            isConversationView
                ? `calc(30vw  + ${token('space.400', '32px')} + ${token('space.025', '2px')} + ${token(
                      'space.150',
                      '12px'
                  )})`
                : `calc(30vw)`,

        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/ensure-design-token-usage
        paddingRight: ({ isConversationView }) =>
            isConversationView ? `calc(30vw  + ${token('space.400', '32px')})` : `calc(30vw)`,
    },
});

// eslint-disable-next-line rulesdir/no-styled-export
export const InputWrapper = styled.div<{ isHighlighted: boolean }>({
    backgroundColor: token('color.background.input', N0),
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: ({ isHighlighted }) =>
        isHighlighted ? token('color.border.brand', B400) : token('color.border', N40A),
    borderRadius: 8,
    position: 'relative',
});

const UnstyledButton = styled.button({
    cursor: 'pointer',
    position: 'relative',
    backgroundColor: 'transparent',
    color: 'transparent',
    border: 0,
    padding: 0,
});

// eslint-disable-next-line rulesdir/no-styled-export
export const IconButton = styled(UnstyledButton)({
    position: 'absolute',
    paddingBlock: 0,
    paddingInline: token('space.100', '8px'),
    top: 0,
    bottom: 0,
    left: token('space.100', '8px'),
    display: 'flex',
    alignItems: 'center',
    borderRadius: '0 3px 3px 0',
    cursor: 'pointer',
    ':hover': {
        '> span': {
            transition: 'transform 140ms',
            transitionTimingFunction: 'ease-in-out',
            transform: 'scale(1.1)',
        },
    },
});
